import styled from 'styled-components';
import Button from 'components/ui/Button';

export const StyledButton = styled(Button)`
  margin: 4px 0;
  padding: 0 8px;
`;
